// extracted by mini-css-extract-plugin
export default {"InputWithComma":"InputWithComma_InputWithComma__+yw8b","Comma":"InputWithComma_Comma__AqWKX"};